import ModelEntity from "../../model2/model-entity"
import {EntityType} from "../../gd/const/item"
import ErrorProto from "../../gd/validation/error"
import ErrorFieldRequired from "../../gd/validation/error-field-required"
import {FieldType} from "../../fields3/field-type"
import FieldConfig from "../../fields3/proto/field-config"
import FieldsCollection from "../../fields3/collection/base/fields-collection"
import FieldUser from "../../fields3/generic/user/user"
import FieldText from "../../fields3/generic/text/text"
import Task from "../../model2/task/task"

export default class StatusUpdateRequestModel extends ModelEntity {

    public fields   : StatusUpdateRequestModelFields
    public userId   : ID
    public comments : string

    constructor(data: any, task: Task) {
        super('id', EntityType.DYNAMIC_MODEL)

        this.fields     = new StatusUpdateRequestModelFields(task)

        this.userId     = data.userId
        this.comments   = data.comments
    }

    validate():ErrorProto[] | null  {
        const errors : any[] = []

        if (!this.userId) errors.push(new ErrorFieldRequired(this.fields.userId))

        if (_.isEmpty(errors)) return null
        else return errors
    }
}

class StatusUpdateRequestModelFields extends FieldsCollection {
    constructor(task: Task) {

        const taskUsers = _.map(task.users, taskUser => {
            const user = gd.session.users.get(taskUser.userId)!
            return {
                value   : user.id,
                label   : user.name,
            }
        })

        const fieldsConfig : FieldConfig[] = [
            {
                fieldId         : 'userId',
                type            : FieldType.USER,
                isRequired      : true,
                noValueOption   : false,
                options         : taskUsers,
                label           : 'From User'
            },
            {
                fieldId         : 'comments',
                type            : FieldType.TEXT,
                label           : 'Comments'
            },
        ]

        super(fieldsConfig)
    }

    get userId():FieldUser      {return this.get('userId') as FieldUser}
    get comments():FieldText    {return this.get('comments') as FieldText}
}